<template>
  <div>
    <div class="flex items-center px-4 py-4 flex-wrap">
      <div class="w-6/12">
        {{ header }}
      </div>
      <div class="w-6/12 justify-end flex"></div>
    </div>

    <div class="w-full flex justify-center py-6 relative">
      <div class="middle-text">
        <div class="w-auto text-center inner-content">
          <b class="w-full block">₦ {{ totalValue }}</b>
          <span class="w-full block opacity-50">Total</span>
        </div>
      </div>
      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: { type: String },
    chartsData: { type: Object, required: true },
  },

  computed: {
    // chart series = slice amounts
    series() {
      if (!this.chartsData) return [0, 0];
      return [
        this.chartsData.corporate?.amount || 0,
        this.chartsData.private?.amount || 0,
      ];
    },

    // slice labels
    labels() {
      return ["Corporate", "Private"];
    },

    //  totalValue() {
    //   const corporate = this.paymentsChart?.corporate?.amount || 0;
    //   const privateAmt = this.paymentsChart?.private?.amount || 0;
    //   const total = corporate + privateAmt;

    //   const formatter = new Intl.NumberFormat("en-NG", {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   });

    //   return formatter.format(total);
    // },


    totalValue() {
      if (!this.chartsData || this.chartsData.total == null) {
        return "0.00";
      }
      const formatter = new Intl.NumberFormat("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(Number(this.chartsData.total));
    },

    // chart options
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#09B78A", "#D72638"],
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: { show: false },
                value: { show: false },
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => this.totalValue,
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { show: false },
            },
          },
        ],
        legend: { show: false },
        labels: this.labels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.middle-text {
  @apply absolute w-full h-full top-0 left-0 flex justify-center items-center;
}
.inner-content {
  @apply relative;
  top: -16px;
}
</style>
